<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/2fdAVq/images/cover.jpg?1684255541217" alt="This image is the cover for the book Canoeing the Boundary Waters Wilderness"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Canoeing the Boundary Waters Wilderness
      </h1>
      <p class="bookDescription body article font2">
        <p>Canoeing the Boundary Waters Wilderness: A Sawbill Log continues the story of wilderness canoeing begun in A Boundary Waters History: Canoeing Across Time, this time offering historical information about black bear attacks on humans, loon calls and behaviors, lightning strikes on the waters, the experience of a woman going into labor while canoeing with her husband, the sighting of spectacular northern lights, and reflections on the wilderness experience. All the while Wilbers reflects on experiences canoeing with his family. As in the first book, quotes from some of Minnesota�s well known wilderness authors appear throughout the manuscript.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Stephen Wilbers
      </h2>
      
      <p class="authorDescription body article">An avid Nordic ski racer, cyclist, sailor, canoeist and remarkably patient angler, Stephen Wilbers has taken sixty-four trips to the Boundary Waters Canoe Area Wilderness, as well as four trips to the wilds of Canada as a Boy Scout and one with his wife, Debbie, to Quetico Provincial Park. All told, he has spent about one year of his sixty-two years wilderness canoeing, and he hopes to make it two years before he dies. His previously published books include A Boundary Waters History: Canoeing Across Time, a history of the Iowa Writers� Workshop, a chapbook of poems titled This Northern Nonsense about Ernest Oberholtzer (the gentle giant who helped save the Boundary Waters from development) and three books of writing instruction, including Writing for Business (winner of a Minnesota Book Award) and Keys to Great Writing.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?13742c0a